<finder-button *ngIf="data.link"
    class="link"
    anchor="true"
    ariaLabel="{{data.link}}"
    (click)="openModal()">
    {{data.link}}
</finder-button>
